import { useCallback, useEffect, useState } from 'react';
import { fetchOrbitMaintenanceMessage, type OrbitMaintenanceMessage } from '../services/OrbitChatService';

const EMPTY_MAINTENANCE_MESSAGE: OrbitMaintenanceMessage = {
  scope: 'global',
  is_enabled: false,
  message: '',
  updated_at: null,
  updated_by_user_id: null,
};

export function useOrbitMaintenanceMessage(clientId?: number) {
  const [banner, setBanner] = useState<OrbitMaintenanceMessage>(EMPTY_MAINTENANCE_MESSAGE);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!clientId || clientId <= 0) {
      setBanner(EMPTY_MAINTENANCE_MESSAGE);
      return EMPTY_MAINTENANCE_MESSAGE;
    }

    setIsLoading(true);
    try {
      const nextBanner = await fetchOrbitMaintenanceMessage(clientId);
      setBanner(nextBanner);
      return nextBanner;
    } finally {
      setIsLoading(false);
    }
  }, [clientId]);

  useEffect(() => {
    let cancelled = false;

    if (!clientId || clientId <= 0) {
      setBanner(EMPTY_MAINTENANCE_MESSAGE);
      return undefined;
    }

    setIsLoading(true);
    fetchOrbitMaintenanceMessage(clientId)
      .then((nextBanner) => {
        if (!cancelled) {
          setBanner(nextBanner);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setBanner(EMPTY_MAINTENANCE_MESSAGE);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [clientId]);

  return {
    banner,
    isLoading,
    refresh,
  };
}

export default useOrbitMaintenanceMessage;

